import { useStore } from 'vuex';
import { computed, unref, watch } from 'vue';
import { useOidc } from '@/composables/oidc';

export const useBuypass = ({ buypassOrgId = null} = {}) => {
  const store = useStore();
  const buypassOrgs = computed(() => store.getters["buypassOrgsStore/orgs"]);
  const buypassOrgsLoaded = computed(() => store.getters["buypassOrgsStore/loaded"]);
  const orgsLoaded = computed(() => store.getters["currentOrgsStore/loaded"]);
  const currentOrg = computed(() => store.getters["currentOrgsStore/org"]);
  const fetchBuypassOrg = store.commit("buypassOrgsStore/fetch");
  const oidc = useOidc();
  const user = computed(() => oidc.user);

  const fetchBuypassOrgsIfRequired = async () => {
    if (!buypassOrgsLoaded.value && unref(buypassOrgId) && orgsLoaded.value) {
      await fetchBuypassOrg({
        personId: unref(user.value.personid),
        buypassId: unref(user.value.buypassid)
      });
    }
  };

  watch(() => orgsLoaded.value,
    async newOrgId => {
      if (newOrgId)
        fetchBuypassOrgsIfRequired();
    });

  watch(() => unref(buypassOrgId),
    async newOrgId => {
      if (newOrgId)
        fetchBuypassOrgsIfRequired();
    });

  const isBuypassAdminForCurrentOrg = computed(() => {
    if (!unref(buypassOrgId) || !buypassOrgsLoaded.value) {
      return false;
    }

    const org = currentOrg(unref(buypassOrgId));

    if (!org?.org?.orgNumber) {
      return false;
    }

    return buypassOrgs.value?.findIndex(x => x?.orgNumber === org.org.orgNumber) > -1;
  });

  fetchBuypassOrgsIfRequired();

  return { isBuypassAdminForCurrentOrg };
};
